"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MessageContentStyle = _styledComponents.default.div`
  padding: 15px 50px 15px 20px;
  white-space: pre-wrap;

  .carbon-content__title {
    margin-bottom: 2px;
  }

  .carbon-content__body {
    margin-top: 0px;
  }

  ${_styledSystem.margin}
`;
var _default = MessageContentStyle;
exports.default = _default;